import React, { useState, useEffect } from "react";
// components

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import LinearProgress from "@mui/material/LinearProgress";
import { FormHelperText } from "@mui/material";
import { useLocation } from "react-router-dom";
import { isCheckingAssessmentType } from "../../../components/common/IsCheckingAssessmentType";

const Assesment = ({ title, change, data, value, isPreview }) => {
  let client = localStorage.getItem("clientName");
  let firstName = client?.split("\n")[0];
  const location = useLocation();
  console.log("location", location);
  let isCheckingSelf = localStorage.getItem("role");

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <Typography
          sx={{
            fontSize: "1.5rem",
            fontWeight: "700",
            fontFamily: "dinBold",
            alignSelf: "flex-start",
            // marginLeft: "1rem",
          }}
          variant="h6"
          component="div"
        >
          Written Response
          {/* {title === "SR" ? "Short Response" :"Short or Long Response"} */}
        </Typography>
      </Grid>
      <Grid item xs={12} md={12}>
        <Typography
          sx={{
            fontSize: "1rem",
            fontWeight: 400,
          }}
          gutterBottom
          component="div"
        >
          Please respond to the following question(s):
        </Typography>
      </Grid>
      <Grid item xs={12} md={12}>
        <Typography
          sx={{
            fontSize: "1rem",
            fontWeight: 400,
          }}
          gutterBottom
          component="div"
        >
          {title === "SR" && data?.aq_clientQuestion && (
            <span style={{ display: "block" }}>
              <strong>Client</strong> - {data?.aq_clientQuestion}
            </span>
          )}

          {title === "SR" && data?.aq_questionName && (
            <span
              style={{
                display: "block",
                marginTop: data?.aq_clientQuestion ? "1rem" : 0,
              }}
            >
              <strong>Assessor</strong> - {data?.aq_questionName}
            </span>
          )}

          {title === "SLR" && data?.aq_clientQuestion && (
            <span style={{ display: "block" }}>
              <strong>Client</strong> -{" "}
              {data?.aq_clientQuestion?.includes("[Leader]")
                ? data?.aq_clientQuestion?.replaceAll(
                    "[Leader]",
                    `Client - <<Client Name>>`,
                  )
                : data?.aq_clientQuestion}
            </span>
          )}

          {title === "SLR" && (
            <span
              style={{
                display: "block",
                marginTop: data?.aq_clientQuestion ? "1rem" : 0,
              }}
            >
              {isCheckingAssessmentType(
                location?.state?.assessmentType?.code,
              ) && (
                <>
                  <strong>Assessor</strong> -{" "}
                  {data?.aq_questionName?.includes("[Leader]")
                    ? data?.aq_questionName?.replaceAll("[Leader]", "Assessor")
                    : data?.aq_questionName}
                </>
              )}
            </span>
          )}
        </Typography>
      </Grid>

      <Grid item xs={12} md={12}>
        {/* {!isPreview && ( */}
        <Stack sx={{ width: "98%", fontSize: "0.8rem", textAlign: "end" }}>
          {(title === "SR" ? 255 : 500) - value?.length <= 0
            ? 0
            : (title === "SR" ? 255 : 500) - value?.length
              ? (title === "SR" ? 255 : 500) - value?.length <= 0
                ? 0
                : (title === "SR" ? 255 : 500) - value?.length
              : title === "SR"
                ? 255
                : 500}{" "}
          Characters remaining
        </Stack>
        {/* )} */}

        <TextField
          multiline
          disabled={isPreview}
          sx={{ width: "100%" }}
          variant="filled"
          hiddenLabel
          placeholder="Enter response"
          inputProps={{
            "aria-label": `${title} response`,
          }}
          // value={value}
          onChange={(e) => change(e, data)}
          helperText={
            title === "SR"
              ? value?.length > 255 && (
                  <FormHelperText error sx={{ color: "red" }}>
                    Response should have less than or equal to 255 characters
                  </FormHelperText>
                )
              : value?.length > 500 && (
                  <FormHelperText error sx={{ color: "red" }}>
                    Response should have less than or equal to 500 characters
                  </FormHelperText>
                )
          }
        />
      </Grid>
    </Grid>
  );
};

export default Assesment;
